
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/ts/src/components/QuestionAnswerAccordion/App.95ce0e29b9a0.tsx";
              export default OriginalModule.default;
              export * from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/ts/src/components/QuestionAnswerAccordion/App.95ce0e29b9a0.tsx";